const task = (taskJson) => {
  const properties = {
    ...taskJson.attributes,
    guid: taskJson.guid,
  };
  return Object.assign(properties);
};

export default task;
